import { Modal, Box, TextField, Button, Grid } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const UpdateOrderModal = ({ order, handleCloseModalEditOrder, openModalEditOrder, updateOrder }) => {

    const handleUpdateOrder = () => {
        const purchaseOrder = document.getElementById('purchase').value;
        const deliveryDate = document.getElementById('date').value;
        const address = document.getElementById('adress').value;

        updateOrder({
            purchaseOrder,
            deliveryDate,
            address,
        });
    };

    return (
        !order ?
            null
            :
            <div>
                <Modal
                    open={openModalEditOrder}
                    onClose={handleCloseModalEditOrder}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    size='small'
                                    label={'Orden de compra'}
                                    defaultValue={order.purchase_order}
                                    id='purchase'
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    size='small'
                                    type='date'
                                    label='Fecha de entrega'
                                    id='date'
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    size='small'
                                    label={'Direccion de entrega'}
                                    id='adress'
                                    defaultValue={order.address_delivery}
                                    required
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Button variant="contained" color="primary" onClick={handleUpdateOrder} >
                                    Actualizar Orden
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                </Modal>
            </div>
    );
}

export default UpdateOrderModal;
